import Button from './Button';

export default Button;

export * from './GreenButton';
export * from './RedButton';
export * from './BlueButton';
export * from './TransparentButton';


// WEBPACK FOOTER //
// ./src/components/Button/index.js